import React, { useState } from "react";
import { Col, Divider, Row } from "antd";
import DashboardLayout from "../../molecules/DashboardLayout";
import FilterSection from "../../modules/Dashboards/Booking/FilterSection";
import CaseCards from "../../modules/Dashboards/Mentainance/MaintenanceOverviewCard";
import TimePeriod from "../../modules/Dashboards/Mentainance/TimePeriod";
import CaseCategory from "../../modules/Dashboards/Mentainance/CaseCategory";
import Recurrence from "../../modules/Dashboards/Mentainance/Recurrence";
import StatusCard from "../../modules/Dashboards/Mentainance/Status";
import RecurrentCard from "../../modules/Dashboards/Mentainance/Recurrent";
import CombinedStatus from "../../modules/Dashboards/Mentainance/CombinedStatus";
import SubLocation from "../../modules/Dashboards/Mentainance/SubLocation";
import RatingsCard from "../../modules/Dashboards/Mentainance/RatingsCard";
import AverageTime from "../../modules/Dashboards/Mentainance/AverageTime";
import CaseAge from "../../modules/Dashboards/Mentainance/CaseAge";
import CasesList from "../../modules/Dashboards/Mentainance/CasesList";
import Location from "../../modules/Dashboards/Mentainance/Location";

const MaintenanceDashboard: React.FC = React.memo(() => {
  const [widgetAccess, setWidgetAccess]: any = useState();
  const [dashboardkey, setDashboardKey] = useState("mentainance");
  return (
    <DashboardLayout>
      <div>
        <FilterSection
          setWidgetAccess={setWidgetAccess}
          setDashboardKey={setDashboardKey}
          dashboardkey={dashboardkey}
        />

        <Divider />

        <div className="main-container">
          <CaseCards />

          <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
            <Col xs={24} sm={12} md={15} lg={15}>
              <TimePeriod />
            </Col>
            <Col xs={24} sm={12} md={9} lg={9} flex="auto">
              <CaseCategory />
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
            <Col xs={24} sm={12} md={6}>
              <Recurrence />
            </Col>
            <Col xs={24} sm={12} md={11}>
              <StatusCard />
            </Col>
            <Col xs={24} sm={12} md={7}>
              <RecurrentCard />
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
            <Col xs={24} sm={12} md={12}>
              <CombinedStatus />
            </Col>
            <Col xs={24} sm={12} md={12}>
              <CombinedStatus />
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
            <Col xs={24} sm={12} md={8}>
              <Location />
            </Col>
            <Col xs={24} sm={12} md={8}>
              <SubLocation />
            </Col>
            <Col xs={24} sm={12} md={8}>
              <RatingsCard />
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
            <Col xs={24} sm={12} md={12}>
              <AverageTime />
            </Col>
            <Col xs={24} sm={12} md={12}>
              <CaseAge />
            </Col>
          </Row>
        </div>
        <CasesList />
      </div>
    </DashboardLayout>
  );
});

export default MaintenanceDashboard;
